import { render } from "./HPHeritage.vue?vue&type=template&id=3b1d2600&scoped=true"
import script from "./HPHeritage.vue?vue&type=script&lang=js"
export * from "./HPHeritage.vue?vue&type=script&lang=js"

import "./HPHeritage.vue?vue&type=style&index=0&id=3b1d2600&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1d2600"]])

export default __exports__